var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackageVerificationInfoCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 16.75C4.75 10.5368 9.7868 5.5 16 5.5C22.2132 5.5 27.25 10.5368 27.25 16.75C27.25 22.9632 22.2132 28 16 28C9.7868 28 4.75 22.9632 4.75 16.75ZM16 4C8.95837 4 3.25 9.70837 3.25 16.75C3.25 23.7916 8.95837 29.5 16 29.5C23.0416 29.5 28.75 23.7916 28.75 16.75C28.75 9.70837 23.0416 4 16 4ZM20.6103 14.1859C20.8511 13.8489 20.773 13.3805 20.4359 13.1397C20.0989 12.8989 19.6305 12.977 19.3897 13.3141L14.9729 19.4976C14.937 19.5479 14.8645 19.5539 14.8208 19.5102L12.5303 17.2197C12.2374 16.9268 11.7626 16.9268 11.4697 17.2197C11.1768 17.5126 11.1768 17.9874 11.4697 18.2803L14.4697 21.2803C14.6256 21.4362 14.8421 21.5156 15.0619 21.4974C15.2816 21.4793 15.4822 21.3653 15.6103 21.1859L20.6103 14.1859Z",
    fill: "#0E7241"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageVerificationInfoCheckCircle);
export default __webpack_public_path__ + "static/media/package-verification-info-check-circle.20dff3a84e2a790083ac7c4bae44527f.svg";
export { ForwardRef as ReactComponent };